import { IEmployer } from "../data_models/employer";


export function getEmployerName(employer: IEmployer): string {
    return employer?.employerName || 'New Employer';
}
 